import React from "react";

import { faTable } from "@fortawesome/pro-regular-svg-icons";
import {
	faChartColumn,
	faChartLine,
	faChartScatterBubble,
	faChartSimple,
	faChartSimpleHorizontal,
	faGrid,
} from "@fortawesome/pro-solid-svg-icons";

import { ChartType as Chart } from "../../store/enums";

import { BarChartOptions } from "./ReportingCharts/BarChart";
import { ColumnChartOptions } from "./ReportingCharts/ColumnChart";
import { HistogramChartOptions } from "./ReportingCharts/HistogramChart";
import { NineBoxChartOptions } from "./ReportingCharts/NineBoxChart";
import { ScatterChartOptions } from "./ReportingCharts/ScatterChart";
import { TrendlineChartOptions } from "./ReportingCharts/TrendlineChart";

type ChartMetaData = {
	[key in Chart]: {
		description: string;
		icon: any;
		title?: string;
		getBaseOptions?: () => React.JSX.Element;
	};
};

const chartMetaData: ChartMetaData = {
	[Chart.NineBox]: {
		description:
			"9-Box: A standard HR visualization that compares employees, managers, or groups on Performance and Potential.",
		icon: faGrid,
		getBaseOptions: () => <NineBoxChartOptions />,
	},
	[Chart.BarChart]: {
		description:
			"A bar chart compares employees, managers, or other groupings across one metric.  Useful for generating a Top 25 chart, for example.",
		icon: faChartSimpleHorizontal,
		getBaseOptions: () => <BarChartOptions />,
	},
	[Chart.ColumnChart]: {
		description:
			"A column chart compares employees, managers, or other groupings across one metric.  Useful for generating a Top 10 chart, for example.",
		icon: faChartSimple,
		getBaseOptions: () => <ColumnChartOptions />,
	},
	[Chart.ScatterChart]: {
		description: "A scatter chart compares employees, managers, or other groupings on two metrics.",
		icon: faChartScatterBubble,
		getBaseOptions: () => <ScatterChartOptions />,
	},
	[Chart.HistogramChart]: {
		description:
			"A distribution chart looks at the distribution of values across one metric.  Useful for visualizing the frequency of certain ranges of scores, for example.",
		icon: faChartColumn,
		title: "Distribution Chart",
		getBaseOptions: () => <HistogramChartOptions />,
	},
	[Chart.TrendlineChart]: {
		description:
			"Trendline chart allows for viewing metrics over time, for example, changes in performance year over year.",
		icon: faChartLine,
		title: "Time Series Chart",
		getBaseOptions: () => <TrendlineChartOptions />,
	},
	[Chart.PieChart]: {
		description:
			"A Pie chart compares employees, managers, or other groupings for one metric.  Useful for viewing relative proportions.",
		icon: null,
	},
	[Chart.Table]: {
		description:
			"A table chart is a data visualization that displays structured data in rows and columns, similar to a spreadsheet.",
		icon: faTable,
	},
};

export { chartMetaData };
